export const baseUrl = 'https://www.sravni.ru';
export const baseMplUrl = 'https://www.sravni.market';
